const initialState = {
  loading: false,
  data: [],
  error: null,
  hasMore: true,
  // filter: "",
};

const userGoalReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_LEADERBOARD_USER_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "FETCH_LEADERBOARD_USER_SUCCESS":
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case "FETCH_LEADERBOARD_USER_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    // case "USER_GOALS_CHANGE_FILTERS":
    //   return {
    //     ...state,
    //     filter: action.payload,
    //   };
    case "EMPTY_LEADERBOARD_STATE":
      return {
        data: null,
        error: null,
        loading: false,
        hasMore: true,
      };
    default:
      return state;
  }
};

export default userGoalReducer;
